import { AnyAction, createSlice } from '@reduxjs/toolkit'
import { ResponseType } from '../interfaces/response'
import { checkUsername, confirmAccount, createNewPassword, signin, signup, verificationAccount, verifyEmail } from '../data-access/apis/authentication/auth'
import { jwtDecode } from 'jwt-decode';
// import { jwtDecode } from 'jwt-decode'

const authLifeCycles = createSlice({
  name: 'auth',
  initialState: {
    status: ResponseType.Pending,
    statusCode: null,
    isConfirmAcc: null,
    user: null,
    token: null,
    schools: null,
    financialYear: null,
    loading: false,
    errors: null,
    message: null,
    usernameAvailable: null,  // add new field to track username availability
  },
  reducers: {
    resetAuth: (state) => {
      state.status = ResponseType.Pending;
      state.statusCode = null;
      state.user = null;
      state.token = null;
      state.schools = null;
      state.financialYear = null;
      state.loading = false;
      state.errors = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signup.pending, (state) => {
        state.loading = true
      })
      .addCase(signup.fulfilled, (state, action: AnyAction) => {
        state.loading = false
        state.message = action.payload.message
        state.statusCode = action.payload.status
        state.status = ResponseType.Success
      })
      .addCase(signup.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.statusCode = action.payload.status
        state.message = action.payload?.data?.message
        state.errors = action.error?.message
        state.status = ResponseType.Failed
      })
      // Handling checkUsername action
      .addCase(checkUsername.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkUsername.fulfilled, (state, action: AnyAction) => {
        state.loading = false;
        state.usernameAvailable = action.payload.available;
        state.message = action.payload.message;
        state.status = ResponseType.Success;
      })
      .addCase(checkUsername.rejected, (state, action: AnyAction) => {
        state.loading = false;
        state.statusCode = action.payload.status;
        state.message = action.payload?.message;
        state.errors = action.error?.message;
        state.status = ResponseType.Failed;
      })
      .addCase(confirmAccount.pending, (state) => {
        state.loading = true
      })
      .addCase(confirmAccount.fulfilled, (state, action) => {
        state.loading = false
        state.message = action.payload?.message
        state.isConfirmAcc = action.payload.success
        state.statusCode = action.payload.status
        state.status = ResponseType.Success
      })
      .addCase(confirmAccount.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.statusCode = action.payload.data?.status
        state.errors = action.payload.data?.errors
        state.status = ResponseType.Failed
      })
      .addCase(signin.pending, (state) => {
        state.loading = true
      })
      .addCase(signin.fulfilled, (state, action) => {
        state.loading = false
        state.statusCode = action.payload.status
        state.token = action.payload.token
        state.user = jwtDecode(state.token ? state.token : '')
        state.message = action.payload?.message
        state.status = ResponseType.Success
      })
      .addCase(signin.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.message = action.payload.data?.message
        state.status = ResponseType.Failed
        state.statusCode = action.payload.data?.status
      })
      .addCase(verifyEmail.pending, (state) => {
        state.loading = true
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.loading = false
        state.message = action.payload.message
        state.statusCode = action.payload.status
        state.status = ResponseType.Success
      })
      .addCase(verifyEmail.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.statusCode = action.payload.data?.status
        state.errors = action.payload.data?.message
        state.status = ResponseType.Failed
      })
      .addCase(verificationAccount.pending, (state) => {
        state.loading = true
      })
      .addCase(verificationAccount.fulfilled, (state, action) => {
        state.loading = false
        state.message = action.payload.message
        state.statusCode = action.payload.status
        state.status = ResponseType.Success
      })
      .addCase(verificationAccount.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.statusCode = action.payload.data?.status
        state.errors = action.payload.data?.message
        state.status = ResponseType.Failed
      })
      .addCase(createNewPassword.pending, (state) => {
        state.loading = true
      })
      .addCase(createNewPassword.fulfilled, (state, action) => {
        state.loading = false
        state.message = action.payload.message
        state.statusCode = action.payload.status
        state.status = ResponseType.Success
      })
      .addCase(createNewPassword.rejected, (state, action: AnyAction) => {
        state.loading = false
        state.statusCode = action.payload.data?.status
        state.errors = action.payload.data?.message
        state.status = ResponseType.Failed
      })
  }
})

export const { resetAuth } = authLifeCycles.actions;
export default authLifeCycles.reducer
